module.exports = __webpack_public_path__ + "img/2.2d3860f5.jpg";